import CommissionDetail from './CommissionDetail';

export default CommissionDetail;
